import { observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import {
  isAdmin,
  isDealer,
  isLooker,
  isOperator,
} from '../../../../services/AccountService'
import CustomAccordion from '../utils/CustomAccordion'
import HistoryInfoElement from './components/HistoryInfoElement'
import OrderHistoryStore from './store/OrderHistoryStore'

const OrderHistory = ({
  id,
  contentState,
  isOrderEdit,
  updateCondition,
  disableLinks = false, // отключает ссылки на отчеты если true
  financialSourceId,
}) => {
  const [historyStore] = useState(() => new OrderHistoryStore())
  const { loadHistory, historyData } = historyStore

  useEffect(() => {
    if (!isOperator() && !isDealer()) {
      if (!isOrderEdit) {
        loadHistory(id)
      }
    }
  }, [id, contentState, isOrderEdit, updateCondition, financialSourceId])

  if (isAdmin() && !isLooker() && !isOperator()) {
    return (
      <CustomAccordion summary={'История изменений'}>
        {historyData.map((item, index) => (
          <HistoryInfoElement
            key={index}
            item={item}
            disableLinks={disableLinks}
          />
        ))}
      </CustomAccordion>
    )
  }

  return null
}

export default observer(OrderHistory)
